import { ExportProfilesQueryParams } from "PFCore/services/export_profiles";
import { ProfilesOptionsParams } from "PFCore/services/profile";

export const profilesKeys = {
  all: (...args) => ["profiles", ...args],
  options: (params: ProfilesOptionsParams) => [...profilesKeys.all(), "options", params],
  exportProfiles: (params: ExportProfilesQueryParams) => [...profilesKeys.all(), "export", params]
};
